import { render } from "./treeItem.vue?vue&type=template&id=650f76a1&scoped=true"
import script from "./treeItem.vue?vue&type=script&lang=js"
export * from "./treeItem.vue?vue&type=script&lang=js"

import "./treeItem.vue?vue&type=style&index=0&id=650f76a1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-650f76a1"]])

export default __exports__